import {
  ChannelTypeEnum,
  ChatType,
  MemberStatus,
  MsgStatus,
  RoomStatus,
  SendingStatus,
  Sex,
} from ".";

export enum WechatAddOriginType {
  /** 通过扫一扫添加 */
  BY_SCAN = 30,
  /** 对方通过名片分享添加 */
  BY_BUSINESSCARD = 17,
  /** 对方通过群聊添加 */
  BY_ROOM = 14,
  /** 通过搜索手机号添加 */
  SEARCH_TEL = 15,
  /** 对方通过搜索账号添加 */
  BY_SEARCH_ACCOUNT = 6,
  /** 通过群聊添加 */
  // BY_ROOM = 4,
}
export enum WechatApplySceneType {
  /** 朋友验证消息 */
  FRIEND_VERIFY_MESSAGE = 6,
  /** 对方通过搜索账号添加 */
  BY_SEARCH_ACCOUNT = 3,
  /** 对方通过分享的名片添加 */
  BY_BUSINESSCARD = 17,
  /** 对方通过扫一扫添加 */
  BY_SCAN = 30,
}

export enum WechatContactType {
  /** 新的朋友 */
  FRIEND_APPLY = "FRIEND_APPLY",
  /** 联系人 */
  SINGLE = "SINGLE",
  /** 群聊 */
  ROOM = "ROOM",
}

export type WechatContact = {
  id?: string;
  account: string;
  avatar: string;
  city: string;
  country: string;
  from_user_id: string;
  is_wecom: boolean;
  name: string;
  province: string;
  remark: string;
  sex: Sex;
  signature: string;
  user_id: string;
  is_friend?: boolean;
  source?: WechatAddOriginType;
};

export type WechatRoomMember = {
  avatar: string;
  display_name: string;
  inviter_id: string;
  is_wecom: boolean;
  name: string;
  status: MemberStatus;
  user_id: string;
};

export type WechatRoom = {
  id?: string;
  room_avatar: string;
  member_list: WechatRoomMember[];
  room_announcement: string;
  room_id: string;
  room_createtime: number;
  room_name: string;
  room_owner_id: string;
  from_user_id: string;
  status?: RoomStatus;
};

export type WechatConversationDataType = {
  chat_id: string;
  team_id?: string;
  name?: string;
  avatar?: string;
  last_message?: WechatMessageType;
  chat_type: WechatContactType;
  from_user_id?: string;
  // 是否置顶
  is_top?: number;
  // 未读数
  unread?: number;
  // 是否屏蔽
  is_shield?: number;
  last_msg_time?: string;
  conversation_robot_relation?: {
    robotId?: string;
  };
  // 是否托管
  is_trusteeship?: boolean;
  // 当前会话的对象
  another_id: string;
  /** 联系人信息 */
  contact?: WechatContact;
  /** 群聊信息 */
  room?: WechatRoom;
};

export type WechatFriendApplyData = {
  id?: string;
  channelType: ChannelTypeEnum;
  avatar: string;
  from_user_id: string;
  is_wecom: boolean;
  name: string;
  sex: Sex;
  signature: string;
  user_id: string;
  apply_time: number;
  apply_reason: string;
  apply_source: WechatApplySceneType;
  accept_request_key?: string;
  is_accept?: boolean;
};

export enum WechatMsgType {
  /** 文本 */
  TEXT = 0,
  /** 文本 */
  TEXT_2 = 2,
  /** 群邀请链接 */
  ROOM_INVITE_LINK = 12,
  /** 链接 */
  LINK = 13,
  /** 红包 */
  HONGBAO = 26,
  /** 企微团队通知 */
  ENTERPRISE_WECHAT_TEAM = 38,
  /** 企微语音通话 */
  WECHAT_CALL = 40,
  /** 好友名片 */
  BUSINESS_CARD = 41,
  /** 企业微信名片 */
  WECOM_BUSINESS_CARD = 42,
  /** 公众号名片 */
  GH_BUSINESS_CARD = 43,
  /** 小程序 */
  MINI_PROGRAM = 78,
  /** 视频 */
  VIDEO = 23,
  /** 企微图片 */
  WECOM_IMAGE = 14,
  /** 个微图片 */
  WECHAT_IMAGE = 101,
  /** 大文件 */
  BIG_FILE = 20,
  /** 大视频 */
  BIG_VIDEO = 22,
  /** 企微视频 */
  WECOM_VIDEO = 23,
  /** 微视频 */
  WECHAT_VIDEO = 103,
  /** 企微微信文件 */
  WECOM_FILE = 15,
  /** 个人微信文件 */
  WECHAT_FILE = 102,
  /** gif */
  GIF = 19,
  GIF_104 = 104,
  /** 位置 */
  LOCATION = 6,
  /** 语音 */
  AUDIO = 16,
  /** 视频号 */
  VIDEO_NUM = 141,
  /** 群发助手 */
  BROADCAST_ASSISTANT = 573,
  /** 系统提示消息 */
  SYSTEM_NOTICE = 1000,
  /** 语音通话 */
  MEETING_VOICE_CALL = 9001,
}

type ExcludeKeys<T, U> = Exclude<keyof T, keyof U>;

type WechatMessageCommonType = {
  chat_id: string;
  another_id: string;
  msg_server_id: string;
  msg_unique_identifier: string;
  msg_type: WechatMsgType;
  request_key?: string;
  sender_id: string;
  timestamp: number;
  from_user_id?: string;
  chat_type?: ChatType;
  to_id?: string;
  /** 消息发送状态 */
  sending_status?: SendingStatus;
  /** 调用发送消息方法时的所有参数，用于发送失败时重新调用发送方法发送 */
  send_message_params?: Record<string, any>;
  /** 标识此条消息是否为撤回的消息 */
  is_revoke?: boolean;
  invoke_msgtype?: number;
  invoke_msg_unique_identifier?: string;
  /** ai回复的ID */
  robot_task_id?: string;
  /** 是否点赞 */
  positive?: boolean;
  /** 纠偏知识id */
  rectifyId?: string;
  /** 消息状态 */
  msg_status?: MsgStatus;
  robotId?: string;
  /** 发送系统用户名 */
  send_sys_user_name?: string;
  /** 撤回系统用户名 */
  recall_sys_user_name?: string;
};
export type WechatMessageBaseType<T extends object> =
  WechatMessageCommonType & {
    [P in ExcludeKeys<T, WechatMessageCommonType>]?: T[P];
  };

export type WechatTextMessageType = WechatMessageBaseType<{
  content: string;
  is_room_notice?: number;
}>;

export type WechatMixedMessageType = WechatMessageBaseType<{
  at_list: { nickname: string; user_id: string }[];
  content: string;
}>;

export type WechatLinkMessageType = WechatMessageBaseType<{
  title: string;
  desc: string;
  thumb_url: string;
  url: string;
}>;

export type WechatRoomInviteLinkMessageType = WechatMessageBaseType<{
  title: string;
  desc: string;
  thumb_url: string;
  url: string;
}>;

export type WechatFileMessageType = WechatMessageBaseType<{
  file_aeskey?: string;
  file_md5?: string;
  file_name: string;
  file_size?: number;
  file_url: string;
}>;
// eslint-disable-next-line @typescript-eslint/ban-types
export type WechatHongBaoMessageType = WechatMessageBaseType<{}>;

export type WechatBusinessCardMessageType = WechatMessageBaseType<{
  avatar: string;
  nickname: string;
  shared_id: string;
}>;

export type WechatWecomBusinessCardMessageType = WechatMessageBaseType<{
  avatar: string;
  nickname: string;
}>;

export type WechatGhBusinessCardMessageType = WechatMessageBaseType<{
  avatar: string;
  nickname: string;
  certInfo: string;
}>;

export type WechatImageMessageType = WechatMessageBaseType<{
  file_url: string;
  file_name: string;
}>;

export type WechatMiniProgramMessageType = WechatMessageBaseType<{
  appid: string;
  cover_image_aeskey: string;
  cover_image_id: string;
  cover_image_md5: string;
  cover_image_size: number;
  headimg: string;
  title: string;
  desc: string;
  username: string;
}>;

export type WechatVideoMessageType = WechatMessageBaseType<{
  file_url: string;
  file_name: string;
}>;

export type WechatGifMessageType = WechatMessageBaseType<{
  file_url: string;
  file_name: string;
}>;

export type WechatLocationMessageType = WechatMessageBaseType<{
  detail: string;
  name: string;
}>;

export type WechatAudioMessageType = WechatMessageBaseType<{
  duration: number;
  file_url: string;
  voice_content?: string;
}>;

export type WechatVideoNumMessageType = WechatMessageBaseType<{
  channel_name: string;
  channel_url: string;
  encode_data: string;
  head_img_url: string;
  username: string;
  thumburl: string;
}>;

export type WechatSystemMessageType = WechatMessageBaseType<{
  content: string;
}>;

// eslint-disable-next-line @typescript-eslint/ban-types
export type WechatWechatCallMessageType = WechatMessageBaseType<{}>;

export type WechatMessageType =
  | WechatTextMessageType
  | WechatMixedMessageType
  | WechatImageMessageType
  | WechatGifMessageType
  | WechatFileMessageType
  | WechatLinkMessageType
  | WechatHongBaoMessageType
  | WechatBusinessCardMessageType
  | WechatMiniProgramMessageType
  | WechatVideoNumMessageType
  | WechatSystemMessageType
  | WechatWechatCallMessageType
  | WechatSystemMessageType;
